import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import { prepareHeaders } from '../../configuration/tokenHandling/prepareHeaders';
import * as api from './generated/api';

export const eventsApi = createApi({
    reducerPath: 'eventsApi',
    baseQuery: fetchBaseQuery({ prepareHeaders }),
    endpoints: builder => ({
        getEventsForStream: builder.query<api.EventsList, string>({
            query: url => ({ url }),
            transformResponse: (x: unknown) => api.EventsList.parse(x),
        }),
    }),
});

export const { useLazyGetEventsForStreamQuery } = eventsApi;
